import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device } from 'components/Variable'

export const FooterNavStyle = styled.div`
	height: ${rem(80)};
	background-color: ${({ theme }) => theme.color.secondary};
	display: flex;
	position: relative;
	align-items: center;
	width: 100%;
	justify-content: space-between;
	padding: ${rem(0, 32)};
	z-index: 10;

	.buttonNext {
		color: ${({ theme }) => theme.color.buttonNextTextColor};
		background-color: ${({ theme }) => theme.color.buttonNextBgColor};
		border-color: ${({ theme }) => theme.color.buttonNextBorderColor};

		svg {
			fill: ${({ theme }) => theme.color.buttonNextTextColor};
		}

		&:hover {
			background-color: ${({ theme }) =>
				theme.color.buttonNextHoverBgColor};
			color: ${({ theme }) => theme.color.buttonNextHoverTextColor};
			border-color: ${({ theme }) =>
				theme.color.buttonNextHoverBorderColor};
			svg {
				fill: ${({ theme }) => theme.color.buttonNextHoverTextColor};
			}
		}
	}

	.buttonBack {
		color: ${({ theme }) => theme.color.buttonBackTextColor};
		background: ${({ theme }) => theme.color.buttonBackBgColor};
		border-color: ${({ theme }) => theme.color.buttonBackBorderColor};

		svg {
			fill: ${({ theme }) => theme.color.buttonBackTextColor};
		}

		&:hover {
			background-color: ${({ theme }) =>
				theme.color.buttonBackHoverBgColor};
			border-color: ${({ theme }) =>
				theme.color.buttonBackHoverBorderColor};
			color: ${({ theme }) => theme.color.buttonBackHoverTextColor};
			svg {
				fill: ${({ theme }) => theme.color.buttonBackHoverTextColor};
			}
		}
	}

	/*@media (${device.tablet}) {
		padding: ${rem(0, 15)};
		background-color: ${({ theme }) => theme.color.blackOne};
		color: ${({ theme }) => theme.color.secondary};
		.buttonBack {
			color: ${({ theme }) => theme.color.secondary};
			background: ${({ theme }) => theme.color.buttonBackMobileBgColor};
			border-color: ${({ theme }) => theme.color.buttonBackMobileBorderColor};
		}
		.buttonNext {
			color: ${({ theme }) => theme.color.secondary};
			background-color: ${({ theme }) => theme.color.buttonNextMobileBgColor};
			border-color: ${({ theme }) => theme.color.buttonNextMobileBorderColor};
		}
	}*/
	@media (${device.mobileM}) {
		padding: ${rem(0, 15)};
	}
`

export const FooterNavBtnText = styled.div`
	display: inline-block;
	position: relative;
	@media (${device.mobileL}) {
		display: none;
	}

	${(p) =>
		p.disabled &&
		css`
			opacity: 0.5;
		`}
`

export const WrapperBtnText = styled.div`
	display: inline-block;
	position: relative;

	${(p) =>
		p.disabled &&
		css`
			opacity: 0.5;
		`}
`

export const FooterNavBtnIcon = styled.div`
	display: none;
	position: relative;

	@media (${device.mobileL}) {
		display: block;
	}

	${(p) =>
		p.left &&
		css`
			transform: rotate(90deg);
			margin-left: ${rem(-3)};
		`}

	${(p) =>
		p.right &&
		css`
			transform: rotate(-90deg);
			margin-right: ${rem(-3)};
		`}
`
